import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { ResetPasswordComponent } from './unauthenticated/reset-password/reset-password.component';
import { RegisterComponent } from './unauthenticated/register/register.component';
import { PageNotFoundComponent } from './unauthenticated/page-not-found/page-not-found.component';
import { SsoauthComponent } from './authenticated/pages/ssoauth/ssoauth.component';
import { SsoLoginComponent } from './unauthenticated/sso-login/sso-login.component';
import { LoginComponent } from './unauthenticated/login/login.component';
import { MsalGuard } from '@azure/msal-angular';


const routes: Routes = [
  {
    path: 'mLogin',
    component: LoginComponent
  },
  {
    path: 'login',
    component: SsoLoginComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'olvide-mi-contrasena',
    component: ResetPasswordComponent,
  },
  {
    path: 'ssoauth',
    component: SsoauthComponent
  },
  {
    path: 'admin-manual-login',
    component: RegisterComponent
  },
  {
    path: '',
    redirectTo: '/mLogin',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
